<template>
    <div class="single-collection-image">
        <ThumbnailBackgroundImage :course="course" isVertical />
        <ThumbnailForegroundLogo :course="course" />
        <ThumbnailPartnerLogo :course="course" />
        <ThumbnailInstructors :course="course" />
    </div>
</template>

<script>
    import ThumbnailInstructors from 'components/shared/global-courses-items/thumbnails/ThumbnailInstructors.vue'
    import ThumbnailPartnerLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailPartnerLogo.vue'
    import ThumbnailForegroundLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailForegroundLogo.vue'
    import ThumbnailBackgroundImage from 'components/shared/global-courses-items/thumbnails/ThumbnailBackgroundImage.vue'


    export default {
        components: { ThumbnailInstructors, ThumbnailPartnerLogo, ThumbnailForegroundLogo, ThumbnailBackgroundImage },
        props: {
            course: {
                type: Object
            }
        }
    }
</script>

<style lang="scss" scoped>
    .single-collection-image {
        position: relative;
        flex-shrink: 0;
        overflow: hidden;
        min-height: 87px;
        display: flex;
        border-radius: 4px 4px 0 0;
        z-index: 0;

        &:after {
            content: '';
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.3) 100%);
            position: absolute;
            bottom: 0;
            top: 0;
            left: 0;
            right: 0;
        }

        [class*="mobile"] & {
            width: 100%;
            height: 100px;
        }
    }
</style>
